import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../common/Button';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 5%;
  background-color: ${({ theme }) => theme.colors.background};
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom: 1px solid rgba(0,0,0,0.05);

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem;
  }
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.secondary};
  font-style: italic;
  cursor: pointer;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }

  a {
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 500;
    font-size: 0.95rem;
    transition: color 0.2s;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: block;
  }
`;

const Header = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (sectionId) => (e) => {
    e.preventDefault();

    const scroll = () => {
      const el = document.getElementById(sectionId);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    if (location.pathname === '/') {
      scroll();
    } else {
      navigate('/');
      setTimeout(scroll, 100);
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      // O comportamento padrão ao navegar é ir para o topo, 
      // mas podemos forçar window.scrollTo(0,0) num useEffect na Home se necessário.
    }
  };

  const handleAuthAction = () => {
    if (user) {
      navigate('/home');
    } else {
      navigate('/login');
    }
  };

  return (
    <HeaderContainer>
      <LogoContainer to="/" onClick={scrollToTop}>es.cu.ta</LogoContainer>

      <Nav>
        <a href="/#funcionalidades" onClick={goToSection('funcionalidades')}>Funcionalidades</a>
        <a href="/#diferenciais" onClick={goToSection('diferenciais')}>Por que nós?</a>
        <a href="/#planos" onClick={goToSection('planos')}>Planos</a>
        
        <Button onClick={handleAuthAction}>
            {user ? 'Minha Conta' : 'Entrar'}
        </Button>
      </Nav>

      <MobileMenuButton onClick={() => navigate('/login')}>
        ☰
      </MobileMenuButton>
    </HeaderContainer>
  );
};

export default Header;